export default __webpack_public_path__ + "static/media/DandyAceLogo.5b5cd018.png";